import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_EVENT_LOGS',
    icon: 'MessageCircleIcon',
    route: 'event-logs',
    action: constants.action.permissionLogin,
    resource: constants.resource.user,
  },
]
